import * as Sentry from '@sentry/react';

import { toast } from '@workspace/ui/components/sonner';
import { API_URL } from '~/config/environment';
import { errors } from '~/errors/errors';

type FetchResponse<T> = T | null;

export async function fetchJson<T>(
  url: string,
  options: RequestInit = {},
  returnError = false,
): Promise<FetchResponse<T>> {
  try {
    const newUrl = `${API_URL}${url}`;
    const response = await fetch(newUrl, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
    });

    if (!response.ok) {
      const errorData = await response.json().catch(async () => {
        return await response.text();
      });

      if (errorData.message !== 'E_ALIAS_NOT_FOUND') {
        Sentry.captureException(
          new Error(`Fetch error: ${response.status} ${response.statusText}`),
          {
            extra: {
              url: newUrl,
              options,
              response: errorData,
            },
          },
        );
      }

      if (returnError) {
        return errorData;
      }

      toast.error(
        errors[errorData.message as keyof typeof errors] ||
          'Ha ocurrido un error',
      );
      throw new Error(
        `Error ${response.status}: ${response.statusText}${errorData.message ? ` - ${errorData.message}` : ''}`,
      );
    }

    return await response.json();
  } catch (error) {
    console.error('Fetch error:', error);
    return null;
  }
}
